export default function deviceLanguage(): string {
  return navigator.language;
}
